module.exports = __webpack_public_path__ + "fonts/d19903f0eb374f079b6472178cd36f47.ef06b6de.ttf";